(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewProfile.controller:ConfirmOtherHubOverlappingDialogCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('crewProfile').controller(
			'ConfirmOtherHubOverlappingDialogCtrl',
			ConfirmOtherHubOverlappingDialogCtrl);

	function ConfirmOtherHubOverlappingDialogCtrl($uibModalInstance,
			modalParams, EventManagerService) {
		var vm = this;
		vm.ctrlName = 'otherHubOverlappingCtrl';

		vm.model = {
			errorMsgs : modalParams.errorMsg || [],
			messages : modalParams.messages || [],
			errors : modalParams.errors || [],
			warnings : modalParams.warnings || [],
			overLapHubHrsRangeDTOS : modalParams.overLapHubHrsRangeDTOS || []
		};

		vm.onCloseClick = function() {
			$uibModalInstance.close(modalParams.close);
		};
		
		vm.ImportWithOverride = function(){
			EventManagerService
			.notifyEventListeners(
					EventManagerService.EVENT.TOOLBAR.OTHER_HUB_HOURS.IMPORT_BY_OVERRIDING,
					true);
			$uibModalInstance.close(modalParams.close);
		}
	}
}());
